import { FormControl, FormLabel, Grid } from "@mui/material";
import { FC } from "react";
import { QuestionnaireItemProps } from ".";
import CustomDatePicker from "../../../../../components/form/CustomDatePicker/CustomDatePicker";

const DateTimeQuestion: FC<QuestionnaireItemProps> = ({
  item,
  onChange,
  value,
  initialValue,
  disabled,
  required,
}) => (
  <Grid>
    <FormControl>
      <FormLabel required={required}>{item.text}</FormLabel>

      <CustomDatePicker
        value={value?.value || initialValue}
        onChange={(date) => onChange(item, date)}
        disabled={disabled}
      />
    </FormControl>
  </Grid>
);

export default DateTimeQuestion;
